// extracted by mini-css-extract-plugin
module.exports = {"product-section":"product-section_product-section__1nD1p","product-column":"product-section_product-column__ubAfv"};